'use client';

import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { useVariantContextValues } from '../../context/use-variant-context-values';
import VariantsContainer from '../variants/variants-container';
import VendorDetails from '../vendor-details';
const Variants = () => {
  const {
    isMobile
  } = useMobileDetect();
  const {
    hasColorOptions,
    hasWeightOptions,
    defaultWeight,
    noVendorDetails
  } = useVariantContextValues('pdp');
  const showVariants = !!hasColorOptions || !!hasWeightOptions || !!defaultWeight;
  if (!showVariants && noVendorDetails) return;
  return <div className='flex w-full flex-col lg:gap-y-3' data-sentry-component="Variants" data-sentry-source-file="variants.tsx">
            {!isMobile && <VendorDetails mode='desktop' />}

            <VariantsContainer contextType='pdp' data-sentry-element="VariantsContainer" data-sentry-source-file="variants.tsx" />
        </div>;
};
export default Variants;